/**
 * Image/PDF ingestion for visual-field/OCT/fundus/topography reports with trendable metadata
 * (`BACKLOG.md` M10). Full DICOM device connectivity is explicitly deferred per the module brief
 * ("each vendor layers a proprietary format on standard DICOM — start with PDF/image import") — this
 * module covers only the PDF/image-import half.
 */

export const IMAGING_REPORT_TYPES = [
  'visual_field',
  'oct',
  'fundus_photo',
  'topography',
  'other',
] as const;
export type ImagingReportType = (typeof IMAGING_REPORT_TYPES)[number];

export function isImagingReportType(value: string): value is ImagingReportType {
  return (IMAGING_REPORT_TYPES as readonly string[]).includes(value);
}

const IMAGING_REPORT_TYPE_LABELS: Readonly<Record<ImagingReportType, string>> = {
  visual_field: 'Visual field',
  oct: 'OCT',
  fundus_photo: 'Fundus photo',
  topography: 'Topography',
  other: 'Other',
};

export function imagingReportTypeLabel(type: ImagingReportType): string {
  return IMAGING_REPORT_TYPE_LABELS[type];
}
